import { createSlice } from "@reduxjs/toolkit";
import { getAllCampaigns, updateCampaignDeduplication, } from "../thunks/campaignThunks";
import {  markToTestAuth, salesforceAuthorize, salesforceoceAuthorize, saveMarkToTestAuth } from "../thunks/customerSettingsThunk";
import { toast } from "react-toastify";

const initialState = {
    isLoading: true,
    error: null,
    campaigns: [],
    CAMPAIGN_GENERATION_TYPES: ['MANUAL', 'ALGORITHM'],
    INGESTION_TYPES : [
        {
            id: 1,
            type: 'Across all channels',
            text: 'process all NPIs from the trigger file',
        },
        {
            id: 0,
            type: 'Across all channels',
            text: 'process only NPIs that match the target list',
        },
        {
            id: 2,
            type: 'Partial ingestion',
            text: 'For Sales Rep channel, process only NPIs from the trigger file that match the target list, but for all other channels, process all NPIs from the trigger file',
        },
    ],
    CONNECTED_APPS: [
        {
            appName: 'Veeva',
            subTitle: "Cloud-based software for the global life sciences industry.",
            isConnected: false,
        },
        {
            appName: 'Marketo',
            subTitle: "The world's largest marketing automation platform.",
            isConnected: false,
        },
        {
            appName: 'Salesforce Marketing Cloud',
            subTitle: "Platform for delivering relevant, personalized journeys across channels and devices",
            isConnected: false,
        },
        {
            appName: 'IQVIA OCE',
            subTitle: "OCE connects sales, marketing, medical and other functions to harmonize interactions with customers.",
            isConnected: false,
        },
        {
            appName: 'AdLib DSP Advertising',
            subTitle: "Most popular websites and apps with the best advertising platform.",
            isConnected: false,
        },
    ],
};

const customerSettings = createSlice({
    name: 'customerSettings',
    initialState,
    reducers: {
        handleDeduplicationChange(state, action) {
            const { value, id } = action.payload;
    
            const updatedCampaigns = state.campaigns.map(item =>
                item.id === id ? { ...item, deduplication: value } : item
            );
    
            return { ...state, campaigns: updatedCampaigns };
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(getAllCampaigns.fulfilled, (state, action) => {
            state.isLoading = false;
            state.campaigns = action.payload.campaigns;
        })
        .addCase(getAllCampaigns.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(getAllCampaigns.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(updateCampaignDeduplication.fulfilled, (state,action) => {
            if(action.payload?.status_code === 200){
                state.error = null;
                state.isLoading = false;
                toast.success("Deduplication updated successfully.")
            }
            else{
                state.isLoading = false;
                toast.error("Please retry!")
            }
            
        })
        .addCase(updateCampaignDeduplication.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(updateCampaignDeduplication.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(salesforceAuthorize.fulfilled, (state,action) => {
            if(action.payload){
                state.error = null;
                state.isLoading = false;
                window.location.href = action.payload?.redirect_url;
                toast.success("Connected successfully.")
            }
            else{
                state.isLoading = false;
                toast.error("Please retry!")
            }
            
        })
        .addCase(salesforceAuthorize.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(salesforceAuthorize.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(salesforceoceAuthorize.fulfilled, (state,action) => {
            if(action.payload){
                state.error = null;
                state.isLoading = false;
                window.location.href = action.payload?.redirect_url;
                toast.success("Connected successfully.")
            }
            else{
                state.isLoading = false;
                toast.error("Please retry!")
            }
            
        })
        .addCase(salesforceoceAuthorize.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(salesforceoceAuthorize.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(markToTestAuth.fulfilled, (state,action) => {
            if(action.payload){
                state.error = null;
                state.isLoading = false;
                toast.success(action.payload?.success)
            }
            else{
                state.isLoading = false;
                toast.error("Please retry!")
            }
            
        })
        .addCase(markToTestAuth.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(markToTestAuth.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(saveMarkToTestAuth.fulfilled, (state,action) => {
            if(action.payload){
                state.error = null;
                state.isLoading = false;
                toast.success(action.payload?.success)
            }
            else{
                state.isLoading = false;
                toast.error("Please retry!")
            }
            
        })
        .addCase(saveMarkToTestAuth.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(saveMarkToTestAuth.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
    }
});


export const { actions } = customerSettings;
export default customerSettings.reducer;
